// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","gn-btn":"gn-btn-f63"};